import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

export const SUPPORTED_LANGS = ['zh-CN', 'en-US'] as const
export type SupportedLang = (typeof SUPPORTED_LANGS)[number]

export const resources = {
  'zh-CN': { translation: zhCN },
  'en-US': { translation: enUS },
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-CN',
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'hibro-lang',
      caches: ['localStorage'],
    },
  })

export default i18n
